import { useNavigate } from "react-router-dom";
import { staticIcons } from "../../../../utils/assessmentSubjectIcons";
import { formatDate } from "../../../../utils/utils";
import "./TestPreview.scss";

const NotAttemptedAssignments = ({ data = [], onView }) => {
  const nav = useNavigate();
  if (!data?.length) return null;

  const handleViewTest = (assessmentID) => {
    const viewTest = data?.find((s) => s.assignment_id === assessmentID);
    nav("/test-unattempted", { state: { viewTest } });
  };
  return (
    <>
      {data.map((card) => {
        const matchedIcon = staticIcons.find(
          (icon) =>
            icon.subject?.toLowerCase() === card?.subject?.toLowerCase(),
        );
        const chapterLabel = Array.isArray(card?.chapter)
          ? card.chapter[0]
          : card?.chapter;

        return (
          <li key={card.assignment_id}>
            <div className="a-card a-card--main">
              <div className="a-card__top">
                <div className="left">
                  <h5 className="m-0 fz22 searchable card-title">
                    {`Test Your ${card?.subject || ""} Knowledge`}
                  </h5>

                  <span className="status-badge status-badge--not-attempted">
                    Not Attempted
                  </span>
                </div>
                <div className="right right--math">
                  <img src={matchedIcon ? matchedIcon.img : null} alt="icon" />
                </div>
              </div>
              <div className="a-card__bottom">
                <p className="fz16 fw400 inner">
                  Here you can get the questions related to {chapterLabel}.
                  Questions can be mcqs, short answers or fill in the blanks.
                  Try to attempt all the questions.
                </p>
                <div className="other-info">
                  <div className="other-info__inner">
                    <div className="left">
                      <img
                        src="./assets/images/inner-pages/icons/icon-clock--blue.svg"
                        alt=""
                      />
                      <span className="ff2 fw500 fz16">
                        {card?.duration_minutes} mins
                      </span>
                    </div>
                    <div className="sep" />
                    <div className="middle">
                      <img
                        src="./assets/images/inner-pages/icons/icon-calendar-blue.svg"
                        alt=""
                      />
                      <span className="ff2 fw500 fz16">
                        {formatDate(card?.start_time)}
                      </span>
                    </div>
                  </div>
                  <div className="right">
                    <button
                      className="border-0 btn btn-solid btn-solid--dark fz16 fw500 ff2"
                      //   onClick={() => onView?.(card)}
                      onClick={() => handleViewTest(card?.assignment_id)}
                    >
                      View
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </li>
        );
      })}
    </>
  );
};

export default NotAttemptedAssignments;
